import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = ["href"]
const _hoisted_11 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_ThumbnailForManagement = _resolveComponent("ThumbnailForManagement")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_CaretTop = _resolveComponent("CaretTop")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_CaretBottom = _resolveComponent("CaretBottom")!
  const _component_VideoDataForm = _resolveComponent("VideoDataForm")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 8,
          class: _normalizeClass(_ctx.$style.relative)
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", {
              class: _normalizeClass(_ctx.$style.top_adjustment)
            }, "動画一覧", 2)
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_el_col, { span: 8 }, {
          default: _withCtx(() => [
            _createElementVNode("p", null, " 現在容量: " + _toDisplayString(Math.round((_ctx.state.privateBucketInUse + _ctx.state.publicBucketInUse) * 100) / 100) + " GB 残り容量 " + _toDisplayString(Math.round((_ctx.state.bucketFull - _ctx.state.publicBucketInUse - _ctx.state.privateBucketInUse) * 100) / 100) + " GB ", 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          span: 8,
          class: _normalizeClass(_ctx.$style.relative)
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", null, [
              _createVNode(_component_el_button, {
                class: _normalizeClass([_ctx.$style.top_adjustment, _ctx.$style.el_button]),
                color: _ctx.BUTTON_COLOR,
                round: true,
                onClick: _ctx.destroyList
              }, {
                default: _withCtx(() => [
                  _createTextVNode("チェックした動画を削除")
                ]),
                _: 1
              }, 8, ["class", "color", "onClick"])
            ])
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      id: _ctx.$style.videoEditAreaParent
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.courseList, (course) => {
        return (_openBlock(), _createElementBlock("div", {
          key: Number(course.id)
        }, [
          _hoisted_2,
          _createElementVNode("h4", null, "コース：" + _toDisplayString(course.title), 1),
          _createElementVNode("i", null, _toDisplayString(course.description), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.videoDataList.filter((videoData) => videoData.courseId === course.id), (videoData) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(_ctx.$style.video_edit_area),
              key: Number(videoData.id)
            }, [
              _createVNode(_component_el_row, {
                class: _normalizeClass(_ctx.$style.el_row)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, {
                    span: 3,
                    class: _normalizeClass(_ctx.$style.relative)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_checkbox, {
                        class: _normalizeClass(_ctx.$style.checkbox),
                        size: "large",
                        modelValue: _ctx.state.selectDestroyVideo[Number(videoData.id)],
                        "onUpdate:modelValue": ($event: any) => ((_ctx.state.selectDestroyVideo[Number(videoData.id)]) = $event)
                      }, null, 8, ["class", "modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["class"]),
                  _createVNode(_component_el_col, { span: 8 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ThumbnailForManagement, { videoData: videoData }, null, 8, ["videoData"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_col, { span: 11 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(_ctx.$style.video_edit_button)
                      }, [
                        _createVNode(_component_el_button, {
                          color: _ctx.BUTTON_COLOR,
                          class: _normalizeClass(_ctx.$style.el_button),
                          round: true,
                          onClick: ($event: any) => (_ctx.editAreaOpen(Number(videoData.id)))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 編集 ")
                          ]),
                          _: 2
                        }, 1032, ["color", "class", "onClick"])
                      ], 2),
                      _createElementVNode("div", {
                        class: _normalizeClass([_ctx.$style[videoData.release ? 'release' : 'private'], _ctx.$style.video_edit_button])
                      }, _toDisplayString(videoData.release ? '公開中' : '非公開'), 3),
                      _createElementVNode("div", {
                        class: _normalizeClass([_ctx.$style.video_edit_button, _ctx.$style.el_button])
                      }, [
                        _createVNode(_component_el_switch, {
                          onChange: ($event: any) => (_ctx.releaseToggle(videoData)),
                          modelValue: videoData.release,
                          "onUpdate:modelValue": ($event: any) => ((videoData.release) = $event),
                          style: {"--el-switch-on-color":"#6da84f"}
                        }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue"])
                      ], 2)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_col, { span: 2 }, {
                    default: _withCtx(() => [
                      _hoisted_3,
                      _hoisted_4,
                      _hoisted_5,
                      _hoisted_6,
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_CaretTop)
                        ]),
                        _: 1
                      }),
                      _hoisted_7,
                      _hoisted_8,
                      _hoisted_9,
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_CaretBottom)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["class"]),
              _createVNode(_component_el_row, {
                class: _normalizeClass(_ctx.$style.video_data)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 10 }, {
                    default: _withCtx(() => [
                      _createTextVNode("公開リンク")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        href: '/video/view/' + videoData.videoViewSrc
                      }, _toDisplayString(`${_ctx.ENDPOINT}/video/view/${videoData.videoViewSrc}`), 9, _hoisted_10)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["class"]),
              _createVNode(_component_el_row, {
                class: _normalizeClass(_ctx.$style.video_data)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 10 }, {
                    default: _withCtx(() => [
                      _createTextVNode("コース")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.getCourse(videoData)), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["class"]),
              (_ctx.state.videoDataRaw.id === Number(videoData.id))
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(_component_VideoDataForm, {
                      courseList: _ctx.state.courseList,
                      stripePlanList: _ctx.state.stripePlanList,
                      defaultInput: _ctx.state.videoDataRaw,
                      defaultInputPlan: _ctx.state.selectPlan,
                      onChanged: _ctx.formChange
                    }, null, 8, ["courseList", "stripePlanList", "defaultInput", "defaultInputPlan", "onChanged"]),
                    _createVNode(_component_el_button, {
                      class: _normalizeClass([_ctx.$style.submit_button, _ctx.$style.el_button]),
                      color: _ctx.BUTTON_COLOR,
                      round: true,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editSubmit()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("編集実行")
                      ]),
                      _: 1
                    }, 8, ["class", "color"])
                  ]))
                : _createCommentVNode("", true)
            ], 2))
          }), 128))
        ]))
      }), 128))
    ], 8, _hoisted_1)
  ]))
}